import { Card, CardContent, CardDescription, CardHeader, CardTitle, WendMark } from '@wend/ui';
import type { ReactNode } from 'react';

export interface AuthLayoutProps {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  /** Rendered under the card — links and secondary actions. */
  footer?: ReactNode;
}

/**
 * The frame for the two screens that exist before there is a session: login and
 * set-password. A single centred card on the ambient ground, with no navigation
 * — there is nowhere to navigate to yet.
 */
export function AuthLayout({ title, description, children, footer }: AuthLayoutProps) {
  return (
    <div className="relative min-h-dvh bg-ink text-text">
      <div className="wend-ambient" aria-hidden="true" />

      <div className="relative z-10 flex min-h-dvh flex-col items-center justify-center px-pad py-12">
        <div className="w-full max-w-[26rem]">
          <div className="mb-7 flex items-center gap-3">
            <WendMark className="size-9" />
            <span className="text-[1.35rem] font-semibold tracking-[-0.03em]">wend</span>
          </div>

          <Card>
            <CardHeader>
              <CardTitle>{title}</CardTitle>
              {description && <CardDescription>{description}</CardDescription>}
            </CardHeader>
            <CardContent>{children}</CardContent>
          </Card>

          {footer && <div className="mt-5 text-[0.85rem] leading-relaxed text-muted">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
